import GroupOfUsersForm from './component'

export default GroupOfUsersForm
